import _regeneratorRuntime from "@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import { postBRRequest } from './../../services/preapproval-api.services';

var catchError = function catchError(error) {
  if (error.response) {
    return {
      status: error.response.status,
      error: error.response.data.message
    };
  } else if (error.request) {
    return {
      status: error.request.status,
      error: error.request.responseText
    };
  } else {
    return {
      status: -1,
      error: error.message
    };
  }
};

export var createPreapprovalLink = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(body) {
    var response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!body.idNumber) {
              _context.next = 11;
              break;
            }

            _context.prev = 1;
            _context.next = 4;
            return postBRRequest("/api/request-preapproval-link-br", body);

          case 4:
            response = _context.sent;
            return _context.abrupt("return", {
              status: response.status,
              data: response.data
            });

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](1);
            return _context.abrupt("return", catchError(_context.t0));

          case 11:
            return _context.abrupt("return", catchError({
              message: 'missing query parameters'
            }));

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 8]]);
  }));

  return function createPreapprovalLink(_x) {
    return _ref.apply(this, arguments);
  };
}();